export interface LookupEmailAddressFoundState {
    status: "found"
    url: string
}

export interface LookupEmailAddressOrgIssueErrorState {
    status: "no-org" | "multi-org"
    email: string
}

export interface LookupEmailAddressNotFoundErrorState {
    status: "not-found"
}

export interface LookupEmailAddressErrorState {
    status: "error"
    errors: {
        email?: string[] | undefined
        general?: string[] | undefined
    }
}

export interface LookupEmailAddressFreshState {
    status: "fresh"
}

export type LookupEmailAddressState =
    | LookupEmailAddressFoundState
    | LookupEmailAddressOrgIssueErrorState
    | LookupEmailAddressNotFoundErrorState
    | LookupEmailAddressErrorState
    | LookupEmailAddressFreshState

export const isLookupEmailAddressFoundState = (state: LookupEmailAddressState): state is LookupEmailAddressFoundState =>
    state.status === "found"

export const isLookupEmailAddressOrgIssueErrorState = (
    state: LookupEmailAddressState
): state is LookupEmailAddressOrgIssueErrorState => state.status === "no-org" || state.status === "multi-org"

export const isLookupEmailAddressNotFoundErrorState = (
    state: LookupEmailAddressState
): state is LookupEmailAddressNotFoundErrorState => state.status === "not-found"

export const isLookupEmailAddressErrorState = (state: LookupEmailAddressState): state is LookupEmailAddressErrorState =>
    state.status === "error"

export const isLookupEmailAddressFreshState = (state: LookupEmailAddressState): state is LookupEmailAddressFreshState =>
    state.status === "fresh"
